import AppStore from '@v4/store/appStore'
import useWordings from '@v4/hooks/useWordings'
import { useMemo } from 'react'
import { useSectionMetaData } from '@v4/components/common/SectionItem'
import useStyles from './QuestionProgress.styled'

export const useQuestionProgress = () => {
	const metaData = useSectionMetaData()
	const classes = useStyles()
	const percent = AppStore.useStoreState(state => state.question.percentage || 0)
	const { getWording } = useWordings()

	const extraShortcuts = useMemo(
		() => ({
			progress_percent: `${percent}%`,
		}),
		[percent],
	)

	return [
		{
			classes,
			percent,
			extraShortcuts,
			progressText: metaData.progressText?.metaValue ?? `<p>${percent}% ${getWording('complete')}</p>`,
		},
	]
}
